/**
 * The one human-readable label for a field record.
 *
 * Fourth term is load-bearing, not defensive. Per FieldZonePlaceholder's
 * rememberViewed: a row or title with no text is an invisible control. The
 * modal shipped without it (F-53) and rendered a blank title.
 *
 * On WHICH records that is reachable — the original note here was wrong and
 * is corrected. Create mode DOES require supplier_tool_id (the Create
 * button's disabled gate in FieldRecordModal.jsx, with a backstop in
 * handleCreateInner's empty-TOOL-ID return), so a record made in the zone
 * can never hit the blank-title case. The
 * reachable path is a record arriving from a LOAD carrying none of
 * supplier_tool_id, tool_description or tool_id. The fourth term is still
 * load-bearing; only its stated reason was wrong.
 *
 * Reads record.working, NOT the record top level. The top level holds only
 * record_id / tool_id / site_id / etag and the child arrays; all 27 editable
 * fields live under working. tool_id is the one term read from the top level
 * because that is where it lives.
 *
 * Standalone module, deliberately NOT part of fieldStore: fieldStore owns
 * Dexie I/O and this is a pure function. The sync sheet imports it and must
 * not pull the store in.
 */
export function recordLabel(record) {
  if (!record) return '';
  return String(
    record.working?.supplier_tool_id
    || record.working?.tool_description
    || record.tool_id
    || record.record_id
    || '',
  );
}

export default recordLabel;
